var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"text-xs font-bold rounded-lg transition hover:opacity-70 inline-flex select-none",class:_vm.size+' '+_vm.flex,attrs:{"to":_vm.href}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }